import { parseContextAri } from '../../iframe/utils/parseContextAri';

export type ContextAriTarget = {
	cloudId: string;
	contextId: string;
};

/**
 * Mirrors the Forge Outbound Proxy rule for `withContext()`: an app may only target sites it is
 * installed in. The ARI must belong to the product of the method being called — `requestJira`
 * only accepts Jira ARIs and `requestConfluence` only Confluence ARIs.
 * The target may be an entry of `installation.contexts[].ari` (as exposed by `view.getContext()`)
 * or the `ari:cloud:<product>::site/<cloudId>` shorthand for one.
 */
export const resolveContextAriTarget = (
	contextAri: string,
	product: string,
	installationContexts: string[],
): ContextAriTarget => {
	if (product !== 'jira' && product !== 'confluence') {
		throw new Error(`contextAri is not supported for product: ${product}`);
	}
	const { resourceOwner, cloudId } = parseContextAri(contextAri);
	if (resourceOwner !== product || !cloudId) {
		throw new Error(`Invalid contextAri: ${contextAri} is not a ${product} site context`);
	}
	const contextId = installationContexts.find((installedAri) => {
		const installed = parseContextAri(installedAri);
		return installed.resourceOwner === product && installed.cloudId === cloudId;
	});
	if (!contextId) {
		throw new Error(`Invalid contextAri: ${contextAri} is not an installation context of this app`);
	}
	return { cloudId, contextId };
};
